module.exports = {"casino-title":"Notifications"}


//////////////////
// WEBPACK FOOTER
// ./src/companies/casino/lang/en/user/notifications.lang.json
// module id = tM2h
// module chunks = 1